import { observer } from 'mobx-react-lite'
import { type TeamViewModel } from '@/features/iam/teams/TeamViewModel'
import { TabBar } from '@/components/TabBar'
import { TabControllerItemsContainer } from '@/components/TabBar/TabControllerItemsContainer'
import { useDocumentTitle } from '@/hooks/document-title'
import { useActivation } from '@/hooks/view-model-hooks'
import { match } from '@/utils/pattern-match-util'
import { Team } from '@/features/iam/teams/components/Team'
import { TeamDetailsContainer } from '@/features/iam/teams/components/TeamDetails/TeamDetailsContainer'
import { TeamMembersContainer } from '@/features/iam/teams/components/TeamMembers/TeamMembersContainer'
import { TeamPaymentsContainer } from '@/features/billing/payment-methods/TeamPayments/TeamPaymentsContainer'

export interface TeamContainerProps {
  vm: TeamViewModel
}

export const TeamContainer = observer(function TeamContainer({
  vm,
}: TeamContainerProps) {
  useActivation(vm)
  useDocumentTitle(`${vm.team.name} — Teams`)

  return (
    <Team
      teamName={vm.team.name}
      teamAvatar={vm.team.avatar}
      isUploadingPicture={vm.uploadPicture.pending}
      onSelectNewPicture={vm.uploadPicture}
      tabBar={
        <TabBar align="left">
          <TabControllerItemsContainer controller={vm.tabs} />
        </TabBar>
      }
    >
      {match(vm.tabs.current.tab, {
        Details: () => <TeamDetailsContainer vm={vm.teamDetailsVm} />,
        PaymentMethods: () => <TeamPaymentsContainer vm={vm.teamPaymentsVm} />,
        Members: () => <TeamMembersContainer vm={vm.teamMembersVm} />,
      })}
    </Team>
  )
})
